import React, { useState } from 'react';

function Contact() {
    
    const [formData, setFormData] = useState({
    firstName: '',
    email: '',
    company: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('https://contact-form-demo-alpha.vercel.app/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: 'Thank you for your message. We will get back to you soon!' });
        setFormData({
          firstName: '',
          email: '',
          company: '',
          message: ''
        });
      } else {
        setSubmitStatus({ type: 'error', message: 'Failed to send message. Please try again.' });
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Failed to send message. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="inner-header text-center heading1">
                <h1>Contact Us</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> <span>Contact Us</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* HERO AREA ENDS */}

      {/* CONTACT AREA STARTS */}
      <div className="contact-inner-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 m-auto">
              <div className="heading2 text-center">
                <h5>
                  <span>
                    <img src="assets/img/icons/sub-logo1.svg" alt="" />
                  </span>
                  Have Questions? Reach Out!
                </h5>
                <div className="space20"></div>
                <h2>Let's Discuss Your IT Needs</h2>
              </div>
              <div className="space40"></div>
              <div className="row justify-content-center text-center">
                <div className="col-lg-4 col-md-6">
                  <div className="widget-contactbox">
                    <div className="icons">
                      <img src="assets/img/icons/mail2.svg" alt="" />
                    </div>
                    <div className="content">
                      <h4>Our Email</h4>
                      <a href="mailto:info@chesteritsolutions.com">info@chesteritsolutions.com </a>
                    </div>
                  </div>
                  <div className="space30 d-lg-none d-block"></div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="widget-contactbox">
                    <div className="icons">
                      <img src="assets/img/icons/phn2.svg" alt="" />
                    </div>
                    <div className="content">
                      <h4>Phone</h4>
                      <a href="tel:07533139643">(+44)-7533139643</a>
                    </div>
                  </div>
                  <div className="space30 d-lg-none d-block"></div>
                </div>
              </div>
              <div className="space60"></div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="img1 reveal image-anime">
                    <img src="assets/img/all-images/others/others-img2.png" alt="" />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="contact-author-boxarea">
                    <h3>Get In Touch Now</h3>
                    <div className="space8"></div>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="input-area">
                          <input 
                            type="text" 
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            placeholder="Name*" 
                          />
                        </div>
                      </div>


                      <div className="col-lg-6">
                        <div className="input-area">
                          <input 
                            type="email" 
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Email Address*" 
                          />
                        </div>
                      </div>
                      
                      <div className="col-lg-12">
                        <div className="input-area">
                          <input 
                            type="text" 
                            name="company"
                            value={formData.company}
                            onChange={handleInputChange}
                            placeholder="Company Name" 
                          />
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="input-area">
                          <textarea 
                            name="message"
                            value={formData.message}
                            onChange={handleInputChange}
                            placeholder="Your Message"
                          ></textarea>
                        </div>
                      </div>
                      
                      <div className="col-lg-12">
                        <div className="space32"></div>
                        <div className="input-area">
                          <button 
                            type="button" 
                            className="vl-btn2"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Sending...' : 'Get Started Now'} <i className="fa-solid fa-arrow-right"></i>
                          </button>
                          {submitStatus && (
                            <div style={{ 
                              marginTop: '1rem',
                              color: submitStatus.type === 'success' ? '#28a745' : '#dc3545',
                              textAlign: 'center'
                            }}>
                              {submitStatus.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* CONTACT AREA ENDS */}
    </>
  )

}
export default Contact
